import React from "react";
import { Container, Title, Button } from "@bsf/force-ui";
import { ExternalLink, Plus } from "lucide-react";
import { __ , sprintf } from "@wordpress/i18n";

const WelcomeContainer = () => {
	return (
		<div>
			<Container
				align="center"
				className="bg-background-primary border-[0.5px] border-subtle rounded-xl shadow-sm mb-6 p-8 flex flex-col lg:flex-row"
				containerType="flex"
				direction="row"
				gap="sm"
			>
				<Container.Item shrink={1}>
					<Title
						description=""
						icon={null}
						iconPosition="right"
						className="max-w-lg"
						size="lg"
						tag="h3"
						title={__("Hello,", "uael")}
					/>
					<p className="text-sm font-medium text-text-tertiary m-0 mt-2">
						{__(
							"Thanks for choosing " +
								uaelSettingsData.plugin_short_name +
								" Pro! You're now part of an exclusive community of website builders. Explore the features and enjoy creating something amazing. Let's take your site to the next level together.",
							"uael"
						)}
					</p>
					<div className="flex items-center pt-6 gap-2">
						{
							uaelSettingsData.is_lite_active ? (
								<>
									<Button
										iconPosition="right"
										variant="primary"
										className="bg-[#6005FF] uael-remove-ring"
										style={{
											backgroundColor: "#6005FF",
											transition: "background-color 0.3s ease",
										}}
										onMouseEnter={(e) =>
											(e.currentTarget.style.backgroundColor =
												"#4B00CC")
										}
										onMouseLeave={(e) =>
											(e.currentTarget.style.backgroundColor =
												"#6005FF")
										}
										onClick={() => {
											window.open(
												uaelSettingsData.uael_hfe_post_url,
												"_blank"
											);
										}}
									>
										{__("Create Header/Footer", "uael")}
									</Button>
									<Button
										icon={<Plus />}
										iconPosition="right"
										variant="outline"
										className="uael-remove-ring"
										style={{
											color: "#6005FF",
											borderColor: "#6005FF",
										}}
										onMouseEnter={(e) =>
											(e.currentTarget.style.color =
												"#000000") &&
											(e.currentTarget.style.borderColor =
												"#000000")
										}
										onMouseLeave={(e) =>
											(e.currentTarget.style.color =
												"#6005FF") &&
											(e.currentTarget.style.borderColor =
												"#6005FF")
										}
										onClick={() => {
											window.open(
												uaelSettingsData.elementor_page_url,
												"_blank"
											);
										}}
									>
										{__("Create New Page", "uael")}
									</Button>
								</>
							) : 
							(
								<Button
									icon={<Plus />}
									iconPosition="right"
									variant="primary"
									className="bg-[#6005FF]"
									style={{
										backgroundColor: "#6005FF",
										transition: "background-color 0.3s ease",
									}}
									onMouseEnter={(e) =>
										(e.currentTarget.style.backgroundColor =
											"#4B00CC")
									}
									onMouseLeave={(e) =>
										(e.currentTarget.style.backgroundColor =
											"#6005FF")
									}
									onClick={() => {
										window.open(
											uaelSettingsData.elementor_page_url,
											"_blank"
										);
									}}
								>
									{__("Create New Page", "uael")}
								</Button>
							)
						}
						<div
							style={{
								color: "black",
								background: "none",
								border: "none",
								padding: 0,
								cursor: "pointer",
							}}
							onMouseEnter={(e) =>
								(e.currentTarget.style.color = "#6005ff")
							}
							onMouseLeave={(e) =>
								(e.currentTarget.style.color = "black")
							}
							onClick={() => {
								window.open(
									"https://ultimateelementor.com/docs/getting-started-uael/",
									"_blank"
								);
							}}
						>
							<Button
								icon={<ExternalLink />}
								iconPosition="right"
								variant="link"
								className="uael-remove-ring text-black"
							>
								{__("Read full guide", "uael")}
							</Button>
						</div>
					</div>
				</Container.Item>
				{/* <Container.Item className="md:mt-0 mt-4">
					<iframe
						width="280"
						height="160"
						src="https://www.youtube.com/embed/ZeogOxqdKJI"
						frameBorder="0"
						style={{ borderRadius: "8px" }}
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
					/>
				</Container.Item> */}
			</Container>
		</div>
	);
};
export default WelcomeContainer;
